import React, { useState, useEffect, useRef } from "react";
import { Line } from "react-chartjs-2";
import Chart from "chart.js/auto";
import { deflate, inflate } from "pako";
import loading_ from "../Assets2/loading.gif";
import bg1 from "../Assets2/screenshot1.png";
import bg2 from "../Assets2/screenshot2.png";
import bg3 from "../Assets2/screenshot3.png";
import bg4 from "../Assets2/screenshot4.png";
import bg5 from "../Assets2/screenshot5.png";
import bg6 from "../Assets2/screenshot6.png";
import bg7 from "../Assets2/screenshot7.png";
import bg8 from "../Assets2/screenshot8.png";
import bg9 from "../Assets2/screenshot9.png";
import bg10 from "../Assets2/screenshot10.png";
import bg11 from "../Assets2/screenshot11.png";
import bg12 from "../Assets2/screenshot12.png";
import "./CSS/Page_Mnagment.css";
import BtnCellRenderer2 from "./BtnCellRenderer2.jsx";
import { Link } from "react-router-dom";
import "./CSS/All.css";
import yuzonbir from "../Assets/a_1.png";
import yuzonikş from "../Assets/a_2.png";
import pcc from "../Assets/a_3.png";
import elec_generator from "../Assets/a_4.png";
import air_chiller_2 from "../Assets/a_5.png";
import boiler from "../Assets/a_6.png";
import chiller from "../Assets/a_7.PNG";
import chiller2 from "../Assets/a_8.jpg";
import esanjor from "../Assets/a_9.PNG";
import valve_png from "../Assets/a_10.png";
import a from "../Assets/a_11.png";
import b from "../Assets/a_12.png";
import c from "../Assets/a_13.png";
import d from "../Assets/a_14.png";
import e from "../Assets/a_15.png";
import f from "../Assets/a_16.png";
import g from "../Assets/a_17.png";
import h from "../Assets/a_18.png";
import i from "../Assets/a_19.png";
import j from "../Assets/a_20.png";
import k from "../Assets/a_21.png";
import l from "../Assets/a_22.png";
import m from "../Assets/a_23.png";
import n from "../Assets/a_24.PNG";
import b2 from "../Assets/a_25.PNG";
import c2 from "../Assets/a_26.PNG";
import d2 from "../Assets/a_27.PNG";
import e2 from "../Assets/a_28.PNG";
import water_chiller from "../Assets/a_29.png";
import analy from "../Assets/6744989.png";
import speedr from "../Assets/3563394.png";
import steam from "../Assets/1724304.png";
import sun_energy from "../Assets/4114970.png";
import redbell from "../Assets/559343.png";
import pontoon from "../Assets/1505455.png";
import carbon_foot from "../Assets/7822060.png";
import { useDispatch, useSelector } from "react-redux";
import Store from "../Store/Store";
import {
  add_page_name,
  add_pop_up_widget,
  clear_pop_up_widget,
  remove_paGE,
  set_current_dyn_pageName,
  set_render_items_toolbox,
  set_temp_id,
  set_toolbox,
  set_white_space,
  set_yetkilendirme_state,
} from "../Action/Action";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import GaugeChart from "react-gauge-chart";
import Draggable from "react-draggable";
import { render } from "react-dom";

import _ from 'lodash';
import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const availableHandles = ['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne'];

const LineChart = ({ data, labels, yAxisName }) => {
  const chartData = {
    labels: labels,
    datasets: [
      {
        label: "Random Data",
        data: data,
        fill: false,
        borderColor: "rgb(75, 192, 192)",
        tension: 0.1,
      },
    ],
  };
  const options = {
    scales: {
      x: {
        title: {
          display: true,
          text: "Zaman",
        },
      },
      y: {
        title: {
          display: true,
          text: yAxisName,
        },
      },
    },
  };

  return (
    <div>
      <Line options={options} data={chartData} />
    </div>
  );
};

const Page_Managment = (props) => {

  const {
    className = 'layout',
    rowHeight = 30,
    onLayoutChange = () => { },
    cols = { lg: 120, md: 10, sm: 7, xs: 3, xxs: 2 },
  } = props;

  console.log(props.pages)

  const [currentBreakpoint, setCurrentBreakpoint] = useState('lg');
  const [compactType, setCompactType] = useState('vertical');
  const [resizeHandles, setResizeHandles] = useState(['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne']);
  const [mounted, setMounted] = useState(false);
  const [layouts, setLayouts] = useState({ lg: [], md: [], sm: [], xs: [], xxs: [] });



  const [tag_values, Set_tag_values] = useState([]);
  const history = useHistory();

  const [min, SetMin] = useState(0);
  const [max, SetMax] = useState(0);
  const [page_id, Set_page_id] = useState("");

  const [pop_up_widget, Set_pop_up_widget] = useState([]);

  const [temp_id, Set_temp_id] = useState("")

  //yetkilendirme
  const [page_management_silme, Set_page_management_silme] = useState(false);
  const [page_management_yazma, Set_page_management_yazma] = useState(false);


  useEffect(() => {
    console.log(
      props.yetkilendirme_state[props.auth_reducer],
      props.auth_reducer
    );

    props.users_list.forEach(x => {

      if (x.userId === props.auth_reducer && x.yetkilendirme) {
        console.log(x);
        let yetki_parse = JSON.parse(x.yetkilendirme)
        let com_id = props.temp_com_id || 2;
        Object.entries(yetki_parse[com_id]).forEach(s => {
          if (s[0] === "Page_Management") {
            if (s[1].S === "t") {
              Set_page_management_silme(true);
            } else {
              Set_page_management_silme(false);
            }

            if (s[1].Y === "t") {
              Set_page_management_yazma(true);
            } else {
              Set_page_management_yazma(false);
            }


          }
        })
      }
    })


    console.log(props.auth_reducer);
  }, [props.auth_reducer, props.tag_ids]);




  const [loading, SetLoading] = useState(true);

  var control = loading;

  const [pages, SetPages] = useState(props.pages);

  useEffect(() => {

    if (props.pages.length > 0) {
      SetPages(props.pages);
      var list__ = props.pages;

      setTimeout(() => {
        SetLoading(false);
        control = false;

      }, 1200);

    } else {
      setTimeout(() => {
        SetLoading(false);
        control = false;
      }, 600);
    }
  }, [props.pages]);

  useEffect(() => {
    if (!control) {
      console.log(control);
    }
  }, [control]);

  const delete_page = async (e) => {
    e.preventDefault();

    control = true;


    var selected_id =
      e.target.parentElement.parentElement.firstElementChild.firstElementChild
        .textContent;
    let sayfa_adi = "";
    props.pages.forEach(x=>{
      if(String(x.pageId)===String(selected_id)){
        sayfa_adi = x.pageName
      }
    })
    //widgets and images db

    // just pages name db

    var confirm = window.confirm(
      "Bu sayfayı silmek istediğinizden emin misiniz?"
    );

    var newlist = []; //for widgets and images
    var newList2 = []; // for pages names

    if (confirm) {
      try {
        let idc = props.temp_com_id < 3 ? 2 : props.temp_com_id;
      
        props.users_list.forEach(async x => {
          // Eğer `yetkilendirme` boş veya geçersizse, boş bir nesne `{}` ata
          let objprev = (x.yetkilendirme && x.yetkilendirme.trim() !== "")
            ? JSON.parse(x.yetkilendirme)
            : {};
      
          let currentTarget = objprev?.[idc] || {}; // Eğer yoksa boş nesne ata
      
          // Sayfa adını sil
          if (currentTarget.hasOwnProperty(sayfa_adi)) {
            delete currentTarget[sayfa_adi];
          }
      
          // Eğer `idc` içindeki tüm yetkiler silindiyse, `idc` anahtarını da kaldır
          if (Object.keys(currentTarget).length === 0) {
            delete objprev[idc];
          }
      
          let updated_yetki = { ...objprev };
      
          if (objprev.hasOwnProperty(props.temp_com_id)) {
            const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/person/SetYetkilendirme", {
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
              },
              method: "POST",
              body: JSON.stringify({
                userId: x.userId,
                yetkilendirme: JSON.stringify(updated_yetki)
              })
            });
      
            const response = await request.json();
            if (request.status === 200 && response && response.length > 0) {
              let obj = { [x.userId]: JSON.parse(response[0].yetkilendirme) };
              Store.dispatch(set_yetkilendirme_state(obj));
            }
            console.log(response);
          }
        });
      } catch (err) {
        console.log(err);
      }
      
      SetLoading(true);
      if (props.pages) {
        props.pages.forEach(async (item) => {
          if (String(item.pageId) === selected_id) {
            try {
              const req_ = await fetch(
                `https://app-rmmsapi.azurewebsites.net/api/pages/DeletePage`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    accept: "application/json",
                  },
                  body: JSON.stringify({
                    PageId: item.pageId,
                  }), // Convert the body object to a JSON string
                }
              );
              const response = await req_.json();

              if (response) {
                await Store.dispatch(remove_paGE(item.pageId))
                SetPages((prevLayout) => {
                  const arr = prevLayout.filter(i => {
                    return i.pageId !== item.pageId
                  })
                  return arr
                })
              }
              console.log(response);
            } catch (err) {
              console.log(err, "aüaüaüaüaüaüüaaü");
            } finally {
            }
          }
        });
      }

      e.target.parentElement.parentElement.parentElement.style.display = "none";

    } else {
      return 0
    }
  };


  const edit_btn_func = (e, text) => {

    function normalizeURLPath(path) {
      const turkishMap = {
        'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
        'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
        'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
      };

      return path.split('').map(char => turkishMap[char] || char).join('');
    }

    text = normalizeURLPath(text);


    text = text.replaceAll(" ", "_");
    history.push(`/pages/${text}/edit`);
  };


  

  return (
    <>
      
      {control === true ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className="loading"
        >
          <img style={{ width: "15%" }} src={loading_} alt="" />
        </div>
      ) : (
        <main className="page_management_main">

          

          <div className="notifications-kapsiyici">
            <div
              className="ag-theme-alpine"
              style={{
                height: "auto",
                maxHeight: "80%",
                maxWidth: "60%",
                overflow: "hidden",
                marginTop: "10%",
              }}
            >
              <div className="redirect_to_dashboard-btn">
                <div style={{ pointerEvents: page_management_yazma ? "all" : "none", opacity: page_management_yazma ? "1" : "0.85", width: "18%" }}
                  onClick={() => {
                    history.push("/dynamicPage")
                  }}>Yeni Sayfa <i className="fa fa-plus"></i></div>

              </div>
              <div className="pages_man">
                <div className="row_inital">
                  <div className="kd">
                    <div className="first">ID</div>
                    <div className="second">Sayfa İsmi</div>
                  </div>
                  <div className="third">Edit</div>
                </div>
                {props.fetch_pages_control ?
                  <>
                    {pages.length > 0 ? (
                      pages.map((i, index) => {
                        return (
                          <div className="rowX">
                            <div className="kd">
                              <div className="first">{i.pageId}</div>
                              <div className="second">{i.pageName}</div>
                            </div>
                            <div className="third">
                              <button
                                disabled={!page_management_yazma}
                                style={{ pointerEvents: page_management_yazma ? "all" : "none" }}
                                onClick={(e) => {
                                  var text =
                                    e.target.parentElement.parentElement
                                      .firstElementChild.firstElementChild
                                      .nextElementSibling.textContent;
                                  console.log(text);

                                  edit_btn_func(e, text);
                                }}
                              >
                                Edit
                              </button>

                              <button
                                disabled={!page_management_silme}
                                style={{ pointerEvents: page_management_silme ? "all" : "none" }}
                                onClick={(e) => {
                                  delete_page(e);
                                }}
                              >
                                Sil
                              </button>
                              <button
                                onClick={() => {
                                  history.push("/flowActive");
                                }}
                              >
                                Program <i class="fa-solid fa-chart-line"></i>
                              </button>
                            </div>
                          </div>
                        );


                      })
                    ) : (
                      <div
                        style={{
                          height: "100vh",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          marginTop: "30%",
                        }}
                        className="loading"
                      >

                        <p
                          style={{
                            marginTop: "10%",
                            fontSize: "21px",
                            color: "rgb(80,80,80)",
                            width: "100%",
                            textAlign: "center",
                            fontWeight: "600",
                            fontFamily:
                              "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
                          }}
                        >
                          Herhangi bir sayfa bulunamadı
                        </p>
                      </div>
                    )}
                  </> :
                  <div
                    style={{
                      height: "100vh",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "30%",
                    }}
                    className="loading"
                  >
                    <img style={{ width: "15%" }} src={loading_} alt="" />

                    <p
                      style={{
                        marginTop: "10%",
                        fontSize: "21px",
                        color: "rgb(80,80,80)",
                        width: "100%",
                        textAlign: "center",
                        fontWeight: "600",
                        fontFamily:
                          "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
                      }}
                    >
                      Sayfalar Yükleniyor. Lütfen Bekleyiniz...
                    </p>
                  </div>

                }
              </div>
            </div>
          </div>
        </main>
      )}
    </>
  );
};

const MapStateToProps = (state) => {
  return {
    pages: state.project_reducer.pages,
    pages_names: state.project_reducer.pages_names,
    auth_reducer: state.auth_reducer.user_id,
    profile: state.project_reducer.profile_infos,
    company_id: state.project_reducer.company_id,
    secret_key: state.project_reducer.secret_key_db_firebase,
    tag_list: state.project_reducer.tag_list,
    current_path: state.project_reducer.current_path,

    sistem_izleme_control: state.project_reducer.sistem_izleme_control,
    profile_infos: state.project_reducer.profile_infos,
    yetkilendirme_state: state.project_reducer.yetkilendirme_state,
    group_id: state.project_reducer.group_id,
    users_list: state.project_reducer.users_list,
    com_id: state.project_reducer.company_id,
    render_items_length: state.project_reducer.render_toolbox_items,
    _tag_ids: state.project_reducer.tag_ids,
    tag_values: state.project_reducer.tag_values,
    temp_id: state.project_reducer.temp_id,
    fetch_pages_control: state.project_reducer.fetch_pages_control,
    temp_com_id: state.project_reducer.temp_com_id



  };
};

export default connect(MapStateToProps)(Page_Managment);
